export const DEFAULT_VIEWPORT_LIGHTS = {
  ambient: {
    name: "ambient_light",
    label: "Ambient Light",
    type: "ambient",
    color: "#f0f8ff",
    intensity: 0.4,
  },
  hemisphere: {
    name: "hemisphere_light",
    label: "Hemisphere Light",
    type: "hemisphere",
    skyColor: "#ffffff",
    groundColor: "#f0f8ff",
    intensity: 0.7,
    position: [0, 1, 0],
  },
  directional: {
    main: {
      name: "main_light",
      color: "#fafafa",
      intensity: 0.7,
      position: [2, 4, 5],
    },
    fill: {
      name: "fill_light",
      color: "#f5f5f5",
      intensity: 0.4,
      position: [-2, 3, 3],
    },
    overhead: {
      name: "overhead_light",
      color: "#e6f3ff",
      intensity: 0.2,
      position: [0, 5, 0],
    },
  },
};

const cloneDefaults = () => ({
  ambient: {
    color: DEFAULT_VIEWPORT_LIGHTS.ambient.color,
    intensity: DEFAULT_VIEWPORT_LIGHTS.ambient.intensity,
  },
  hemisphere: {
    skyColor: DEFAULT_VIEWPORT_LIGHTS.hemisphere.skyColor,
    groundColor: DEFAULT_VIEWPORT_LIGHTS.hemisphere.groundColor,
    intensity: DEFAULT_VIEWPORT_LIGHTS.hemisphere.intensity,
  },
});

let viewportLightingOptions = cloneDefaults();
const listeners = new Set();

const clampIntensity = (value) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return 0;
  return Math.max(0, Math.min(5, numeric));
};

const normalizeColor = (value, fallback) =>
  typeof value === "string" && /^#[0-9a-f]{6}$/i.test(value.trim()) ? value.trim() : fallback;

export function getViewportLightingOptions() {
  return viewportLightingOptions;
}

export function subscribeViewportLightingOptions(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function setViewportLightingOptions(patch = {}) {
  const next = {
    ambient: {
      ...viewportLightingOptions.ambient,
      ...(patch.ambient || {}),
    },
    hemisphere: {
      ...viewportLightingOptions.hemisphere,
      ...(patch.hemisphere || {}),
    },
  };
  next.ambient.color = normalizeColor(next.ambient.color, viewportLightingOptions.ambient.color);
  next.ambient.intensity = clampIntensity(next.ambient.intensity);
  next.hemisphere.skyColor = normalizeColor(
    next.hemisphere.skyColor,
    viewportLightingOptions.hemisphere.skyColor
  );
  next.hemisphere.groundColor = normalizeColor(
    next.hemisphere.groundColor,
    viewportLightingOptions.hemisphere.groundColor
  );
  next.hemisphere.intensity = clampIntensity(next.hemisphere.intensity);

  if (
    next.ambient.color === viewportLightingOptions.ambient.color &&
    next.ambient.intensity === viewportLightingOptions.ambient.intensity &&
    next.hemisphere.skyColor === viewportLightingOptions.hemisphere.skyColor &&
    next.hemisphere.groundColor === viewportLightingOptions.hemisphere.groundColor &&
    next.hemisphere.intensity === viewportLightingOptions.hemisphere.intensity
  ) {
    return viewportLightingOptions;
  }

  viewportLightingOptions = next;
  listeners.forEach((listener) => listener());
  return viewportLightingOptions;
}

export function updateViewportLight(kind, patch = {}) {
  if (kind === "ambient") return setViewportLightingOptions({ ambient: patch });
  if (kind === "hemisphere") return setViewportLightingOptions({ hemisphere: patch });
  return viewportLightingOptions;
}

export function resetViewportLightingOptions() {
  return setViewportLightingOptions(cloneDefaults());
}
